export interface IOptionalSetMapMethod {
  setMap?(map: H.Map): void;
}
